import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";

class FormDetails extends Component {
  static propTypes = {
    pageContent: PropTypes.object.isRequired
  };

  render() {
    const { pageContent } = this.props;

    return (
      <div className="formDetails">
        <h1>{pageContent.formDetails.title}</h1>
        <ReactMarkdown source={pageContent.formDetails.body} />
      </div>
    );
  }
}

FormDetails.propTypes = {};

export default FormDetails;
